import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { ParDueDiligenceService } from '../../../services/par-due-diligence/par-due-diligence.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ChangeLogService } from '../../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../../services/google_analytics/google-analytics.service';
@Component({
  selector: 'app-par-due-diligence-delete-dialog',
  templateUrl: './par-due-diligence-delete-dialog.component.html',
  styleUrls: ['./par-due-diligence-delete-dialog.component.css']
})
export class ParDueDiligenceDeleteDialogComponent implements OnInit {
  errFlag: boolean = false;
  errMsg: any;
  logFormData: any;
  loginId: any;
  DocTypeErrMsg: any;
  DocTypeErr:boolean = false;
  firstName;
  lastName;
  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private changelogservice: ChangeLogService,
    private parDueDiligenceService: ParDueDiligenceService,
    public dialogRef: MatDialogRef<ParDueDiligenceDeleteDialogComponent>, @Inject(MAT_DIALOG_DATA)
    public parData: any, ) { }

    onNoClick(): void {
      this.dialogRef.close();
    }

  ngOnInit() {
    this.DocTypeErr = false;
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
  }

  removeDocument() {
    this.logFormData = {
      "document_type": this.parData.DocumentTypeName,
      "document_category": this.parData.DocumentCategory,
      "transaction_type": "Delete"
    }
    this.parDueDiligenceService.deleteDocument(this.parData._id).subscribe(res=>{
      this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Delete a" + ' ' + this.parData.DocumentTypeName + ' ' + 'Document', 'PAR North America', 10);
      this.onNoClick();
      this.parDueDiligenceService.load.next('success');
      this.logFormData.modified_by = this.loginId;
      this.changelogservice.sendLogs(this.logFormData).subscribe(res => {},err=>{
        this.errMsg = 'PAR Change Logs' + ' ' + err;
        this.errFlag = true;
      });
    }, error => {
      this.DocTypeErrMsg = 'PAR Due Diligence Service' + ' ' + error;
      this.DocTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/par-due-diligence/par-due-diligence-delete-dialog/par-due-diligence-delete-dialog.component.ts